import { useEffect } from 'react';
import { createFileRoute, Outlet, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { useAuth } from '@/modules/auth/hooks/useAuth';
import { requiresProfileCompletion } from '@/modules/auth/lib/profileCompletion';
import { isElevatedUser } from '@/modules/auth/lib/userMode';
import { PortalLoadingState } from '@/modules/portal/components/ui/portal-loading';
import { PortalShell } from '@/shared/layout/PortalShell';

export const Route = createFileRoute('/portal')({
  component: PortalLayout,
});

function PortalLayout() {
  const { t } = useTranslation();
  const { user, isAuthLoading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAuthLoading && !user) {
      void navigate({ to: '/auth/login', replace: true });
      return;
    }
    if (!isAuthLoading && user && requiresProfileCompletion(user)) {
      void navigate({ to: '/complete-profile', replace: true });
      return;
    }
    if (!isAuthLoading && user && isElevatedUser(user)) {
      void navigate({ to: '/dashboard', replace: true });
    }
  }, [user, isAuthLoading, navigate]);

  if (isAuthLoading) {
    return (
      <div className="portal-shell flex min-h-screen items-center justify-center">
        <PortalLoadingState message={t('common.loading')} />
      </div>
    );
  }

  if (!user || isElevatedUser(user) || requiresProfileCompletion(user)) {
    return null;
  }

  return (
    <PortalShell user={user}>
      <Outlet />
    </PortalShell>
  );
}
